import { labelOfRole } from "../../util/labelOf";
import { logoutUser } from "../../store/user/actions";
import { useDispatch } from "react-redux";

const AccountPopover = props => {
  const dispatchito = useDispatch();

  const exit = () => {
    props.setOpen(false);
    props.setAnchorEl(null);
    dispatchito(logoutUser());
  };

  // console.debug("props.customerName: ", props.customerName);
  // console.debug("props.user.role: ", props.user.role);
  // console.debug("labelOfRole(props.user.role): ", labelOfRole(props.user.role));
  return (
    <div className="popover-container">
      <div className="popover-item user-info">
        <span style={{ paddingBottom: 0 }}>
          <b>
            {props.user.firstName} {props.user.lastName}{" "}
          </b>
        </span>
        {props.user.role !== "" && (
          <span className="role" style={{ paddingBottom: 0 }}>
            {labelOfRole(props.user.role)}
          </span>
        )}
        {props.customerName !== "" && (
          <span className="company">{props.customerName}</span>
        )}
      </div>
      <div className="popover-item logout-link" id="account-popover-item-logout-link" onClick={() => exit()}>
        <span>Sign out</span>
      </div>
    </div>
  );
};

export default AccountPopover;
